import { useTranslations } from "../i18n";
import type { IDateLocale } from "../utils/date";
import { dateLocaleOf } from "../utils/date";

/** The date rules of the current language and format locale (cached per pair). */
export function useDateLocale(): IDateLocale {
  const { language, formatLocale } = useTranslations();
  return dateLocaleOf(language, formatLocale);
}
